import React, {Component} from 'react';
import { NavLink } from 'react-router-dom';

// Data
import Navigation from '../../data/Navigation.json';

const MainFooterNav = props => {
    let renderNav = Navigation[props.nav];

    return renderNav.map((item,i) => {
        if (item.path.indexOf('://') > 0 || item.path.indexOf('//') === 0 || item.path === '#' ) {
            return <li key={i}><a className={item.classes} target="_blank" href={item.path}>{item.name}</a></li>
        }
        return <li key={i}><NavLink className={item.classes} to={item.path}>{item.name}</NavLink></li>
            
    }); 
}

class FooterNavigation extends Component {

    render () {
        return (
            <nav className="footer-nav">
                <ul>
                    <MainFooterNav nav="footer"/>
                </ul>
                 <ul>
                    <MainFooterNav nav="footerSupport"/>
                </ul>
                <ul>
                    <MainFooterNav nav="footerSocial"/>
                </ul>
            </nav>
        );
    }
}

export default FooterNavigation;


// WEBPACK FOOTER //
// ./src/containers/Footer/FooterNavigation.js